export default "__VITE_ASSET__DhtbD72Y__"